import React from "react";
import "./HeaderStyles.css";

function Logo({ children, ...restProps }) {
  return (
    <div className="container-logo">
      <a className="logo-container" href="/" {...restProps}>
        {children}
        <img className="logo" href="/" src="./images/misc/FibraLink_logo.png" alt="FibraLink logo" />
      </a>
    </div>
  );
}

export default Logo;
